export enum PlasticsHardwareItemType {
    Colorant = 'colorant',
    Decorative = 'decorative',
    Electronics = 'electronics',
    Fastener = 'fastener',
    Sealing = 'sealing',
    CustomerSupplied = 'customer supplied',
    Printed = 'printed',
    Miscellaneous = 'miscellaneous',
    MetalsSupplied = 'metals supplied',
    Insert = 'insert',
    Packaging = 'packaging',
    Resin = 'resin',
    Spinweld = 'spinweld',
    Wheel = 'wheel',
    ShopSupplies = 'shop supplies',
}